import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText } from "lucide-react";
import { AnexoUploader } from "@/components/anexos/AnexoUploader";
import { AnexosList } from "@/components/anexos/AnexosList";
import { ConvergenciaProvasList } from "@/components/anexos/ConvergenciaProvasList";
import { useQueryClient } from "@tanstack/react-query";

interface AnexosTabProps {
  pedidoId: string;
  clienteId: string;
}

export default function AnexosTab({ pedidoId, clienteId }: AnexosTabProps) {
  const qc = useQueryClient();

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="flex items-center gap-2">
          <FileText className="h-5 w-5" />
          Anexos do Cliente
        </CardTitle>
        <AnexoUploader 
          pedidoId={pedidoId}
          clienteId={clienteId}
          onUploadSuccess={() => {
            qc.invalidateQueries({ queryKey: ['anexos_crm'] });
          }}
        />
      </CardHeader>
      <CardContent>
        <ConvergenciaProvasList clienteId={clienteId} pedidoId={pedidoId} />
        <AnexosList clienteId={clienteId} pedidoId={pedidoId} />
      </CardContent>
    </Card>
  );
}
